import { IApplicationState } from '../../types/redux';
import { TCompareType } from '../../types/compareType';

export function selectCompareType(state: IApplicationState): TCompareType {
  return state.comparison.compareType;
}
